<template>

    <div class="layout__container">

        <div class="layout__padding-20px">
            <div class="text__align-center text__colour-white layout__margin__bottom-25px">
                <div class="layout__padding-clear layout__width-50 layout__padding-20-0 layout__border__bottom-light-teal-1px">
                    <h3 class="text__colour-teal">Modify Bespoke Order</h3>
                </div>
            </div>
            <div class="component__columns-2 layout__border__all-1px-grey">
                <div class="layout__padding-20px">
                    <el-form :model="bespokeOrder" ref="bespokeOrder" :rules="rules"
                             class="layout__width-100 layout__position-left">
                        <div class="text__colour-teal">Order Details</div>
                        <div class="component__forms-4">
                            <p class="text_colour-909399 text__size-16">Bespoke Id</p>
                            <p class="component__form__values" v-if="this.bespokeOrder.code">
                                {{this.bespokeOrder.code}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                        </div>

                        <el-form-item prop="zdTicket" class="component__forms-4">
                            <div class="layout__position-left layout__padding-clear layout__padding__top-6px">Zendesk
                                ID<span
                                        class="text__colour-red">*</span></div>
                            <el-input v-model="bespokeOrder.zdTicket" class="layout__position-left">
                            </el-input>
                        </el-form-item>
                        <div class="eft component__forms-4">
                            <p class="text_colour-909399 text__size-16">Status</p>
                            <p class="component__form__values" v-if="this.bespokeOrder.status">
                                {{this.bespokeOrder.status}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                        </div>
                        <div class="component__forms-4">
                            <p class="text_colour-909399 text__size-16">Created</p>
                            <p class="component__form__values" v-if="this.bespokeOrder.created">
                                {{formatDateDDMMYYYYCreated(this.bespokeOrder)}}</p>
                            <p class="component__form__values" v-else>-</p>
                            <br>
                        </div>

                        <div class="layout__padding-clear">

                        </div>
                        <el-form-item prop="jobName" class="component__forms-2">
                            <div class="layout__position-left layout__padding-clear layout__padding__top-6px">Job
                                Name<span class="text__colour-red">*</span></div>
                            <el-input v-model="bespokeOrder.jobName" class="layout__position-left">
                            </el-input>
                        </el-form-item>

                        <div class="component__forms-2 layout__padding-20-0">
                            <p class="text_colour-909399 text__size-16">Customer Name</p>
                            <p class="component__form__values" v-if="this.bespokeOrder.name">
                                {{this.bespokeOrder.name}}</p>
                            <p class="component__form__values" v-else>-</p>
                        </div>
                        <el-form-item prop="contact" class="component__forms-2">
                            <div class="component__forms__fields__labels">Contact Name</div>
                            <el-input v-model="bespokeOrder.contact" class="layout__position-left">
                            </el-input>
                        </el-form-item>

                        <!--<div class="eft component__forms-2 layout__padding-20-0">-->
                        <!--<p class="text_colour-909399 text__size-16">Customer Name</p>-->
                        <!--<p class="component__form__values" v-if="this.bespokeOrder.name">-->
                        <!--{{this.bespokeOrder.name}}</p>-->
                        <!--<p class="component__form__values" v-else>-</p>-->
                        <!--<br>-->
                        <!--</div>-->


                        <!--<div class="component__forms-2">-->
                        <!--<el-button class="button-red button__base__admin layout__width-100 layout__margin__top-30" v-on:click="showBranchSearch('invoice')">Find Branch-->
                        <!--</el-button>-->
                        <!--</div>-->

                        <!--<div class="component__forms-2 layout__padding-20-0">-->
                        <!--<p class="text_colour-909399 text__size-16">Branch Code</p>-->
                        <!--<p class="component__form__values" v-if="this.bespokeOrder.branch">-->
                        <!--{{this.bespokeOrder.branch}}</p>-->
                        <!--<p class="component__form__values" v-else>-</p>-->
                        <!--<br>-->
                        <!--</div>-->

                        <!--&lt;!&ndash; todo add error no matching branch code and maybe waiting wheel&ndash;&gt;-->

                        <!--<span class="layout__position-left component__forms-2 layout__margin-30-0">-->
                        <!--<el-button class="button-red button__base__admin" v-on:click="getBranchDetails()"-->
                        <!--:disabled="this.bespokeOrder.branch === ''">Find Branch-->
                        <!--</el-button>-->
                        <!--</span>-->

                        <div class="component__forms-2 layout__padding-20-0">
                            <p class="text_colour-909399 text__size-16">Salesperson</p>
                            <p class="component__form__values" v-if="this.bespokeOrder.salesperson">
                                {{this.bespokeOrder.salesperson}}</p>
                            <p class="component__form__values" v-else>-</p>
                        </div>
                        <el-form-item prop="user" class="component__forms-2">
                            <div class="">Assigned To</div>
                            <el-select v-model="bespokeOrder.user" filterable placeholder="Select Assigned To"
                                       clearable>
                                <el-option
                                        v-for="user in users"
                                        :key="user.name"
                                        :label="user.name"
                                        :value="user.name">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item prop="deliveryType" class="component__forms-2">
                            <div>Delivery Type<span
                                    class="text__colour-red">*</span></div>
                            <el-select v-model="bespokeOrder.deliveryType" placeholder="Select Delivery Type"
                                       clearable>
                                <el-option
                                        v-for="delivery in ravensworth.deliveryType.options"
                                        :key="delivery.id"
                                        :label="delivery.text"
                                        :value="delivery.value">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <span class="layout__border__top-1px-909399 layout__position-left layout__width-100 layout__margin-25-0">
                <div class="text__colour-teal text__size-18 layout__margin__top-20px">Billing & Delivery Details</div>
            </span>
                        <!--<div class="component__forms-2">-->
                        <!--<el-form-item prop="deliveryDepot" class="">-->
                        <!--<el-input v-model="bespokeOrder.deliveryDepot" class="layout__position-left">-->
                        <!--</el-input>-->
                        <!--</el-form-item>-->
                        <!--</div>-->

                        <div class="component__forms-2">
                            <h4>Billing Address</h4>
                            <div class="">
                                <el-button class="button-red button__base__admin layout__width-100"
                                           v-on:click="showBranchSearch('invoice')">Find Invoice Branch
                                </el-button>
                            </div>
                            <div class="layout__padding-20-0">
                                <el-form-item prop="branch" class="">
                                    <div class="component__forms__fields__labels">Branch Code</div>
                                    <el-input v-model="bespokeOrder.branch" class="layout__position-left" :disabled="true">
                                    </el-input>
                                </el-form-item>






                                <div class="layout__padding-20-0">
                                    <p class="text__size-16 text_colour-909399">Invoice Name, Address and Postcode</p>
                                    <p class="component__form__values text__white_space-pre-line text__line-height-2"
                                       v-if="this.bespokeOrder.invoiceAddress">
                                        {{this.bespokeOrder.invoiceAddress}}</p>
                                    <p class="component__form__values" v-else>-</p>
                                </div>


                            </div>
                        </div>
                        <div class="component__forms-2">
                            <h4>Delivery Address</h4>
                            <div class="">
                                <el-button class="button-teal button__base__admin layout__width-100"
                                           v-on:click="showBranchSearch('delivery')">Find Alternative Delivery Branch
                                </el-button>
                            </div>
                            <div class="layout__padding-20-0">
                                <p class="text__size-16 text_colour-909399">Delivery Branch Code</p>
                                <p class="component__form__values" v-if="this.bespokeOrder.deliveryDepot">
                                    {{this.bespokeOrder.deliveryDepot}}</p>
                                <p class="component__form__values" v-else>-</p>
                            </div>
                            <div class="">
                                <p>Delivery name and address</p>
                                <p class="component__form__values" v-if="this.bespokeOrder.deliveryName">
                                    {{this.bespokeOrder.deliveryName}}</p>
                                <p class="component__form__values" v-else>-</p>

                                <p class="component__form__values" v-if="this.bespokeOrder.deliveryAddress1">
                                    {{this.bespokeOrder.deliveryAddress1}}</p>
                                <p class="component__form__values" v-else>-</p>

                                <p class="component__form__values" v-if="this.bespokeOrder.deliveryAddress2">
                                    {{this.bespokeOrder.deliveryAddress2}}</p>
                                <p class="component__form__values" v-else>-</p>

                                <p class="component__form__values" v-if="this.bespokeOrder.deliveryTown">
                                    {{this.bespokeOrder.deliveryTown}}</p>
                                <p class="component__form__values" v-else>-</p>

                                <p class="component__form__values" v-if="this.bespokeOrder.deliveryCounty">
                                    {{this.bespokeOrder.deliveryCounty}}</p>
                                <p class="component__form__values" v-else>-</p>
                            </div>
                            <div class="layout__padding-20-0">
                                <p>Delivery postcode</p>
                                <p class="component__form__values" v-if="this.bespokeOrder.deliveryPostcode">
                                    {{this.bespokeOrder.deliveryPostcode}}</p>
                                <p class="component__form__values" v-else>-</p>

                            </div>
                        </div>
                    </el-form>
                    <el-button class="button-red button__base__admin layout__margin-25-0 layout__margin__right-10px"
                               v-on:click="saveBespokeOrder('bespokeOrder')">Save
                    </el-button>
                    <el-button class="button-teal button__base__admin layout__margin__right-10px"
                               v-on:click="">Cancel
                    </el-button>
                    <el-button class="button-red button__base__admin layout__margin__right-10px"
                               :disabled="true" v-on:click="">Delete
                    </el-button>
                    <div id="message"></div>
                </div>
            </div>


            <div class="component__columns-2 layout__border__all-1px-grey layout__margin__bottom-25px">
                <div class="layout__padding-20px">
                    <div class="layout__padding-clear text__colour-teal">
                        Bespoke Order Item Tools
                    </div>
                    <div class="layout__padding-20px">
                        <el-button
                                class="button-teal button__base__admin layout__position-left layout__margin__bottom-25px"
                                v-on:click="toogleGrid()">View Order Items
                        </el-button>
                        <el-button
                                class="button-red button__base__admin layout__position-right layout__margin__bottom-25px"
                                :disabled="this.bespokeOrder.code === ''" v-on:click="toggleNewItem()">New Order Item
                        </el-button>
                    </div>
                </div>
            </div>

            <div class="component__columns-2 layout__border__all-1px-grey layout__margin__bottom-25px"
                 v-show="showGrid">
                <div class="layout__padding-20px">
                    <div class="layout__padding-clear text__colour-teal">
                        Bespoke Order Items
                    </div>
                    <div class="layout__padding-20px">
                        <el-table :data="bespokeOrderItems" style="width: 100%;" v-on:row-click="viewOrderItem"
                                  :default-sort="{prop: 'id', order: 'descending'}" v-loading.lock="bespokeOrderItemsLoading">
                            <el-table-column prop="orderId" label="Order Id">
                            </el-table-column>
                            <el-table-column prop="jobId" label="Job Id">
                            </el-table-column>
                            <el-table-column prop="status" label="Status">
                            </el-table-column>
                            <el-table-column prop="sourceType" label="Type">
                            </el-table-column>
                            <el-table-column prop="quantity" label="Quantity">
                            </el-table-column>
                            <el-table-column prop="productCode" label="Product">
                            </el-table-column>
                            <el-table-column prop="jobName" label="Item Description">
                            </el-table-column>
                            <el-table-column prop="billNetTotal" label="Value">
                            </el-table-column>
                        </el-table>

                    </div>
                </div>
            </div>

            <div class="component__columns-2 layout__border__all-1px-grey" v-show="showOrderItem">
                <div class="layout__padding-20px">
                    <div class="layout__padding-clear text__colour-teal">
                        Bespoke Order Item
                    </div>
                    <div class="layout__padding-20px">

                        <el-form :model="bespokeOrderItem" ref="bespokeOrderItem" :rules="rules"
                                 class="layout__width-100 layout__position-left">
                            <div class="component__forms-4">
                                <p class="text_colour-909399 text__size-16">Customer Id</p>
                                <p class="component__form__values" v-if="this.bespokeOrderItem.orderId">
                                    {{this.bespokeOrderItem.orderId}}</p>
                                <p class="component__form__values" v-else>-</p>
                                <br>
                            </div>
                            <div class="component__forms-4">
                                <el-form-item prop="status">
                                    <p>Status</p>
                                    <el-select v-model="bespokeOrderItem.status" placeholder="Select Status"
                                               clearable>
                                        <el-option
                                                v-for="itemStatus in ravensworth.itemStatus.options"
                                                :key="itemStatus.id"
                                                :label="itemStatus.text"
                                                :value="itemStatus.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>


                            <div class="component__forms-4">
                                <p class="text_colour-909399 text__size-16">Created</p>
                                <p class="component__form__values" v-if="this.bespokeOrderItem.created">
                                    {{formatDateDDMMYYYYCreated(this.bespokeOrderItem)}}</p>
                                <p class="component__form__values" v-else>-</p>
                                <br>
                            </div>
                            <div class="component__forms-4">
                                <p class="text_colour-909399 text__size-16">PDC Id</p>
                                <p class="component__form__values" v-if="this.bespokeOrderItem.jobId">
                                    {{this.bespokeOrderItem.jobId}}</p>
                                <p class="component__form__values" v-else>-</p>
                                <br>
                            </div>
                            <div class="layout__padding-clear">
                                <div class="component__forms-2">
                                    <p class="text_colour-909399 text__size-16">Order Filename</p>
                                    <p class="component__form__values" v-if="this.bespokeOrderItem.orderFilename">
                                        {{this.bespokeOrderItem.orderFilename}}</p>
                                    <p class="component__form__values" v-else>-</p>
                                    <br>
                                </div>
                                <div class="component__forms-2">
                                    <p class="text_colour-909399 text__size-16">Item Description</p>
                                    <p class="component__form__values" v-if="this.bespokeOrderItem.billDescription">
                                        {{this.bespokeOrderItem.billDescription}}</p>
                                    <p class="component__form__values" v-else>-</p>
                                    <br>
                                </div>
                            </div>
                            <div class="layout__padding-clear">
                                <el-form-item prop="productCode">
                                    <p>Product Code<span class="text__colour-red">*</span></p>
                                    <el-select v-model="bespokeOrderItem.productCode" placeholder="Search Product Code"
                                               filterable
                                               clearable v-on:change="getProductRefProperties()">
                                        <el-option
                                                v-for="product in productCodes"
                                                :key="product.productRef"
                                                :label="product.productRef"
                                                :value="product.productRef">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="component__forms-4">

                                <el-form-item prop="style">
                                    <div class="layout__position-left">Style</div>
                                    <el-input v-model="bespokeOrderItem.style" class="layout__position-left">
                                    </el-input>
                                </el-form-item>

                                <el-form-item prop="Lamination">
                                    <div class="layout__position-left">Lamination</div>
                                    <el-input v-model="bespokeOrderItem.lamination" class="layout__position-left">
                                    </el-input>
                                </el-form-item>
                            </div>

                            <div class="component__forms-4">
                                <el-form-item prop="sourceType">
                                    <p>Item Type</p>
                                    <el-select v-model="bespokeOrderItem.sourceType" placeholder="Select Item Type"
                                               clearable>
                                        <el-option
                                                v-for="printSourceType in ravensworth.printSourceType.options"
                                                :key="printSourceType.id"
                                                :label="printSourceType.text"
                                                :value="printSourceType.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item prop="paperType">
                                    <div class="layout__position-left">Paper Stock</div>
                                    <el-input v-model="bespokeOrderItem.paperType" class="layout__position-left">
                                    </el-input>
                                </el-form-item>
                            </div>
                            <div class="component__forms-4">
                                <el-form-item prop="pageSize">
                                    <div class="layout__position-left layout__padding-clear">Page Size</div>
                                    <el-input v-model="bespokeOrderItem.pageSize"
                                              class="layout__position-left layout__width-100">
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="sides">
                                    <p>Print Sides</p>
                                    <el-select v-model="bespokeOrderItem.sides" placeholder="Select Print Sides"
                                               clearable>
                                        <el-option
                                                v-for="side in ravensworth.side.options"
                                                :key="side.id"
                                                :label="side.text"
                                                :value="side.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>

                            <div class="component__forms-4">
                                <el-form-item prop="orientation">
                                    <p>Orientation</p>
                                    <el-select v-model="bespokeOrderItem.orientation" placeholder="Select Orientation"
                                               clearable>
                                        <el-option
                                                v-for="orientation in ravensworth.orientation.options"
                                                :key="orientation.id"
                                                :label="orientation.text"
                                                :value="orientation.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <!-- todo finishing-->
                                <el-form-item prop="finishing" class="layout__padding-clear">
                                    <p>Finishing</p>
                                    <el-select v-model="bespokeOrderItem.finishing" placeholder="Select Finishing"
                                               clearable>
                                        <el-option
                                                v-for="otherFinishingStuffSmcTbd in ravensworth.otherFinishingStuffSmcTbd.options"
                                                :key="otherFinishingStuffSmcTbd.id"
                                                :label="otherFinishingStuffSmcTbd.text"
                                                :value="otherFinishingStuffSmcTbd.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>


                            <div class="">


                                <el-form-item prop="specialInstructions" class="layout__padding-clear">
                                    <p class="layout__position-left">Special Instructions</p>
                                    <el-input type="textarea" :rows="3" v-model="bespokeOrderItem.specialInstructions"
                                              class="layout__position-left">
                                    </el-input>
                                </el-form-item>
                            </div>


                            <!--<span class="layout__position-left layout__width-100 layout__margin-25-0">-->
                            <span class="layout__border__top-1px-909399 layout__position-left layout__width-100 layout__margin-25-0">
                <div class="text__colour-teal layout__margin__top-20px">Order Item Price</div>
            </span>

                            <div class="component__forms-4">
                                <el-form-item prop="quantity" class="">
                                    <p class="layout__position-left">Quantity<span class="text__colour-red">*</span></p>
                                    <el-input v-model="bespokeOrderItem.quantity"
                                              class="layout__position-left layout__width-100"
                                              v-on:blur="getPrice()">
                                    </el-input>
                                </el-form-item>
                                <div class="">
                                    <p class="text_colour-909399 text__size-16">Net Total</p>
                                    <p class="component__form__values" v-if="this.bespokeOrderItem.billNetTotal">
                                        {{returnFormattedCurrency(this.bespokeOrderItem.billNetTotal)}}</p>
                                    <p class="component__form__values" v-else>-</p>
                                    <br>
                                </div>

                            </div>

                            <div class="component__forms-4">
                                <el-form-item prop="priceMethod" class="">
                                    <p>Price Method<span class="text__colour-red">*</span></p>
                                    <el-select v-model="bespokeOrderItem.priceMethod" placeholder="Select Price Method"
                                               filterable clearable v-on:change="getPrice()">
                                        <el-option
                                                v-for="priceMethod in ravensworth.priceMethod.options"
                                                :key="priceMethod.id"
                                                :label="priceMethod.text"
                                                :value="priceMethod.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <div class="">
                                    <p class="text_colour-909399 text__size-16">VAT Total</p>
                                    <p class="component__form__values" v-if="this.bespokeOrderItem.billVatTotal">
                                        {{returnFormattedCurrency(this.bespokeOrderItem.billVatTotal)}}</p>
                                    <p class="component__form__values" v-else>-</p>
                                    <br>
                                </div>

                            </div>

                            <div class="component__forms-4">

                                <el-form-item prop="billPrice" class="">
                                    <div class="layout__position-left">Unit Price<span class="text__colour-red">*</span>
                                    </div>
                                    <el-input v-model="bespokeOrderItem.billPrice" class="layout__position-left">
                                    </el-input>
                                </el-form-item>
                                <div class="">
                                    <p class="text_colour-909399 text__size-16">Gross Total</p>
                                    <p class="component__form__values" v-if="this.bespokeOrderItem.billGrossTotal">
                                        {{returnFormattedCurrency(this.bespokeOrderItem.billGrossTotal)}}</p>
                                    <p class="component__form__values" v-else>-</p>
                                    <br>
                                </div>
                            </div>

                            <div class="component__forms-4">
                                <el-form-item prop="focReason">
                                    <p>FOC Reason</p>
                                    <el-select v-model="bespokeOrderItem.focReason" placeholder="Select FOC reason"
                                               clearable>
                                        <el-option
                                                v-for="status in ravensworth.focReason.options"
                                                :key="status.id"
                                                :label="status.text"
                                                :value="status.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-form>

                        <el-button class="button-red button__base__admin layout__margin__right-10px"
                                   v-on:click="updateOrder('bespokeOrderItem')">Save
                        </el-button>
                        <el-button class="button-teal button__base__admin layout__margin__right-10px"
                                   v-on:click="">Cancel
                        </el-button>
                        <el-button class="button-red button__base__admin layout__margin__right-10px"
                                   :disabled="true" v-on:click="">Delete
                        </el-button>

                        <div id="messageItem"></div>

                        <div class="layout__width-100">
                            <span class="layout__border__top-1px-909399 layout__position-left layout__width-100 layout__margin-25-0">
                <div class="text__colour-teal layout__margin__top-20px">Order Item Artwork</div>
            </span>
                            <el-dialog
                                    :visible.sync="showUploadDialog"
                                    :close-on-press-escape="false"
                                    :close-on-click-modal="false"
                                    width="900px">
                                <div class="component__login-dialogue layout__padding-clear" v-show="showUploadDialog">
                                    <OrderArtworkUpload v-bind:bespokeOrder="bespokeOrder"
                                                        v-bind:bespokeOrderItem="bespokeOrderItem"
                                                        v-bind:artwork="artwork"></OrderArtworkUpload>
                                    <el-button class="layout__display-none" id="closeUpload"
                                               v-on:click="getLatestArtwork()">
                                    </el-button>
                                </div>
                            </el-dialog>


                            <el-table
                                    :data="artwork">
                                <el-table-column
                                        prop="sourceId"
                                        label="Source Id"
                                        width="100">
                                </el-table-column>
                                <el-table-column
                                        prop="created"
                                        label="Created"
                                        width="100"
                                        :formatter="formatDateDDMMYYYYCreated">
                                </el-table-column>
                                <el-table-column
                                        prop="filename"
                                        label="Filename"
                                        width="200">
                                </el-table-column>
                                <el-table-column
                                        prop="description"
                                        label="Description"
                                        width="200">
                                </el-table-column>
                                <el-table-column width="100">
                                    <template slot-scope="props">
                                            <img class="layout__width-20px layout__position-center"  v-on:click="downloadArtwork(props.row)"
                                                 src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/sdownload.png">
                                    </template>
                                </el-table-column>
                            </el-table>

                            <el-button class="button-teal button__base__admin layout__margin__top-20"
                                       :disabled="bespokeOrderItem.orderId === ''"
                                       v-on:click="showUploadDialog = true">Upload Artwork
                            </el-button>

                            <span class="layout__border__top-1px-909399 layout__position-left layout__width-100 layout__margin-25-0">
                <div class="text__colour-teal layout__margin__top-20px">Send Order to Print</div>
            </span>
                            <div class="layout__margin__top-20">
                                <el-button class="button-red button__base__admin"
                                           :disabled="artwork.length === 0"
                                           v-on:click="sendOrderToPrint('bespokeOrderItem')">Send To Print
                                </el-button>
                            </div>
                            <div id="messageOrderPrint"></div>
                        </div>

                    </div>
                </div>
            </div>
            <!--<div class="layout__padding-clear">-->
            <!--{{this.artwork.length}}<br>-->
            <!--{{this.artwork}}-->
            <!--</div>-->

            <el-button class="layout__display-none" id="updateOrderInformation"
                       v-on:click="updateOrderInformation()">getUpdatedOrder
            </el-button>
        </div>


        <el-dialog
                :visible.sync="showBranchSearchDialog"
                width="900px">
            <div class="layout__width-100">
                <AddressSearch v-bind:bespokeOrder="bespokeOrder" v-bind:searchType="searchType"></AddressSearch>
                <el-button class="layout__display-none" id="showBranchSearchDialog"
                           v-on:click="showBranchSearchDialog = false">close
                </el-button>
            </div>
        </el-dialog>


    </div>

</template>

<script>
    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {backing} from '@/mixins/Backing.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {Loading} from 'element-ui';
    import OrderArtworkUpload from "../tools/orderArtworkUpload/OrderArtworkUpload.vue";
    import AddressSearch from "../../components/bespoke/AddressSearch.vue";

    export default {
        name: "adminOrders",
        components: {
            OrderArtworkUpload,
            AddressSearch
        },
        mixins: [axios, dataFormatter, backing, csvDownloadHelper],
        props: {
            bespokeOrder: Object,
            bespokeOrderItem: Object
        },
        data() {
            const focReason = (rule, value, callback) => {
                if (this.bespokeOrderItem.priceMethod === 'FOC' && this.bespokeOrderItem.focReason === '') {
                    callback(new Error('enter a foc reason required'));
                } else if (this.bespokeOrderItem.priceMethod !== 'FOC' && this.bespokeOrderItem.focReason !== '') {
                    callback(new Error('please remove foc reason - price method not \'FOC\''));
                } else {
                    callback();
                }
            };
            return {
                searchType: '',
                showBranchSearchDialog: false,
                showGrid: true,
                showOrderItem: false,
                productCodes: [],
                users: [],
                artwork: [],
                bespokeOrderItemsLoading: false,
                bespokeOrderItems: [],
                showUploadDialog: false,
                rules: {
                    zdTicket: [
                        {
                            required: true,
                            message: 'Zendesk Id required',
                            trigger: 'blur'
                        },
                    ],
                    branch: [
                        {
                            required: true,
                            message: 'Branch Code required',
                            trigger: 'blur'
                        },
                    ],
                    deliveryType: [
                        {
                            required: true,
                            message: 'Delivery Type required',
                            trigger: 'blur'
                        },
                    ],
                    jobName: [
                        {
                            required: true,
                            message: 'Job Name required',
                            trigger: 'blur'
                        },
                    ],
                    productCode: [
                        {
                            required: true,
                            message: 'Product Code required',
                            trigger: 'blur'
                        },
                    ],
                    quantity: [
                        {
                            required: true,
                            message: 'Quantity required',
                            trigger: 'blur'
                        },
                    ],
                    priceMethod: [
                        {
                            required: true,
                            message: 'Price Method required',
                            trigger: 'blur'
                        },
                    ],
                    billPrice: [
                        {
                            required: true,
                            message: 'Unit Price required',
                            trigger: 'blur'
                        },
                    ],
                    focReason: [{
                        validator: focReason
                    }]
                }
            }
        },
        created() {

            this.isUserAuthorised();

            const getUsers = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search/userLookup?`
            Axios.get(getUsers, this.returnHeaderUsingToken())
                .then(response => {
                    console.log('rifat')
                    console.log(response.data.value)
                    this.users = response.data.value
                })

            const getProductCodes = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search/productLookup`
            console.log(getProductCodes)
            Axios.get(getProductCodes, this.returnHeaderUsingToken())
                .then(response => {
                    this.productCodes = response.data.value
                })

            // if ((this.bespokeOrder == null || typeof this.bespokeOrder == 'undefined') && window.sessionStorage.getItem('_bespokeOrder') !== null) {
            //     this.bespokeOrder = JSON.parse(window.sessionStorage.getItem('_bespokeOrder'))
            // }

            if ((this.bespokeOrder == null || typeof this.bespokeOrder == 'undefined') && window.sessionStorage.getItem('_bespokeOrder') !== null) {
                this.bespokeOrder = JSON.parse(window.sessionStorage.getItem('_bespokeOrder'))
            }
            if (this.bespokeOrder == null || typeof this.bespokeOrder == 'undefined') {
                this.getNewOrderHeader()
            } else {
                this.getAllOrderItems()
            }

            if (this.bespokeOrderItem == null || typeof this.bespokeOrderItem == 'undefined') {
                this.getNewOrderItem()
            }
        },
        methods: {
            getNewOrderItem() {
                this.bespokeOrderItem = {
                    id: '',
                    orderId: '',
                    sourceId: '',
                    status: 'DRAFT',
                    created: '',
                    jobId: '',
                    orderFilename: '',
                    billDescription: '',
                    productCode: '',
                    style: '',
                    lamination: '',
                    sourceType: '',
                    paperType: '',
                    pageSize: '',
                    sides: '',
                    orientation: '',
                    finishing: '',
                    specialInstructions: '',
                    quantity: '',
                    priceMethod: '',
                    billPrice: '',
                    billNetTotal: '',
                    billVatTotal: '',
                    billGrossTotal: '',
                    focReason: '',
                    source: '',
                    branch: '',
                    artworkFiles: []
                }

                this.artwork = []
            },
            getNewOrderHeader() {
                this.bespokeOrder = {
                    code: '',
                    zdTicket: '',
                    status: '',
                    created: '',
                    branch: '',
                    name: '',
                    contact: '',
                    email: '',
                    jobName: '',
                    salesperson: '',
                    user: '',
                    deliveryType: '',
                    deliveryName: '',
                    deliveryAddress1: '',
                    deliveryAddress2: '',
                    deliveryTown: '',
                    deliveryCounty: '',
                    deliveryPostcode: '',
                    comments: '',
                    deliveryDepot: '',
                    invoiceAddress: ''
                }
            },
            toggleNewItem() {
                this.showOrderItem = true;
                this.showGrid = false;
                this.getNewOrderItem()
                this.resetMessages()
            },
            toogleGrid() {
                this.getAllOrderItems()
                this.showOrderItem = false;
                this.showGrid = true;
                this.resetMessages()
            },
            resetMessages() {
                // document.getElementById("message").classList.add('layout__display-none')
                // document.getElementById("messageItem").classList.add('layout__display-none')
                // document.getElementById("messageItem").style.display = 'none';

                this.showHideElements("messageOrderPrint", 'none')
                this.showHideElements("messageItem", 'none')
                this.showHideElements("message", 'none')


                // document.getElementById("messageOrderPrint").classList.add('layout__display-none')
            },

            showHideElements(element, style) {
                document.getElementById(element).style.display = style;
            },
            getAllOrderItems() {
                console.log('**********************')
                const getBespokeOrderItems = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search/bespokeSearchById?bespokeId=` + this.bespokeOrder.code
                console.log(getBespokeOrderItems)
                this.bespokeOrderItemsLoading = true;
                Axios.get(getBespokeOrderItems, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log('rifat')
                        console.log(response.data)
                        // this.users = response.data.value
                        this.bespokeOrderItems = response.data.value
                        this.bespokeOrderItemsLoading = false;
                        // this.bespokeOrderItems.created = this.bespokeOrderItems.created.split("T")[0] + ' ' + this.bespokeOrderItems.created.split("T")[1].split("Z")[0]
                    })
                    .catch(error => {
                        this.bespokeOrderItemsLoading = false
                    })
            },
            getProductRefProperties() {

                let loadingInstance = Loading.service({
                    // fullscreen: true,
                    background: 'white'
                });

                console.log('++++++++++++++++++++')

                const getproducts = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search/productLookupByRef?productRef=` + this.bespokeOrderItem.productCode
                console.log(getproducts)
                Axios.get(getproducts, this.returnHeaderUsingToken())
                    .then(response => {
                        // console.log('get products')
                        console.log(response.data.value[0])
                        const product = response.data.value[0]


                        // `https://testtkaccountsapi.azurewebsites.net/odata/prodstyles?$filter=code+eq+%27F002%27`
                        const getProductRefProperties = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search/productStyleLookupByStyle?productRef=` + product.style
                        console.log(getProductRefProperties)
                        Axios.get(getProductRefProperties, this.returnHeaderUsingToken())
                            .then(response => {
                                console.log('get products')
                                console.log(response.data.value)
                                const productStyle = response.data.value[0]
                                // this.bespokeOrderItem.style = response.data.value.style

                                this.bespokeOrderItem.style = product.style
                                this.bespokeOrderItem.paperType = product.paperWeight
                                this.bespokeOrderItem.pageSize = productStyle.pageWidth + ' x ' + productStyle.pageHeight + ' mm'
                                this.bespokeOrderItem.sides = productStyle.sides
                                // todo orientation
                                this.bespokeOrderItem.orientation = productStyle.pageOrientation
                                this.bespokeOrderItem.specialInstructions = productStyle.finishingInstructions
                                this.bespokeOrderItem.lamination = product.finishing
                                this.bespokeOrderItem.sourceType = product.press

                                // this.bespokeOrderItem.

                                this.getPrice()

                                this.$nextTick(() => { // Loading should be closed asynchronously
                                    loadingInstance.close();
                                });
                            })
                            .catch(error => {
                                this.$nextTick(() => { // Loading should be closed asynchronously
                                    loadingInstance.close();
                                });
                            })
                    })
                    .catch(error => {
                        this.$nextTick(() => { // Loading should be closed asynchronously
                            loadingInstance.close();
                        });
                    })

            },
            viewOrderItem(order) {
                this.bespokeOrderItem = order
                // this.toggleNewItem()

                this.showOrderItem = true;
                this.showGrid = false;

                this.getLatestArtwork()
            },
            saveBespokeOrder(bespokeOrder) {
                console.log(this.bespokeOrder)
                console.log(this.returnHeaderUsingToken())
                this.$refs[bespokeOrder].validate((valid) => {
                    if (valid) {

                        let loadingInstance = Loading.service({
                            // fullscreen: true,
                            background: 'white'
                        });

                        if (this.bespokeOrder.code === '' || this.bespokeOrder.code === null || typeof this.bespokeOrder.code == 'undefined') {
                            const saveOrder = `${process.env.VUE_APP_BESPOKEAPIHOST}/api/v1/bespokeapi/BespokeOrders`
                            console.log(saveOrder)
                            Axios.post(saveOrder, this.bespokeOrder, this.returnHeaderUsingToken())
                                .then(response => {
                                    console.log('doing a bespoke post')
                                    console.log(response)
                                    this.bespokeOrder = response.data.bespoke
                                    this.bespokeOrder.created = this.bespokeOrder.created.split("T")[0] + ' ' + this.bespokeOrder.created.split("T")[1].split(".")[0]
                                    // window.sessionStorage.setItem('_bespokeOrderHeader', JSON.stringify(this.$parent.bespokeOrder));

                                    this.$nextTick(() => { // Loading should be closed asynchronously
                                        loadingInstance.close();
                                    });

                                    document.getElementById("message").innerText = "Order Successfully Updated"
                                    document.getElementById("message").classList.add('component__message-base', 'component__message-success')
                                    this.showHideElements("message", 'block')
                                })
                                .catch(error => {
                                    this.$nextTick(() => { // Loading should be closed asynchronously
                                        loadingInstance.close();
                                    });
                                    document.getElementById("message").innerText = "There was a problem updating the order - please try again"
                                    document.getElementById("message").classList.add('component__message-base', 'component__message-fail')
                                    this.showHideElements("message", 'block')
                                })
                        } else {
                            const saveOrder = `${process.env.VUE_APP_BESPOKEAPIHOST}/api/v1/bespokeapi/BespokeOrders`
                            console.log(saveOrder)
                            {
                                {
                                    this.bespokeOrder
                                }
                            }
                            Axios.put(saveOrder, this.bespokeOrder, this.returnHeaderUsingToken())
                                .then(response => {
                                    console.log('doing a bespoke post')
                                    console.log(response)
                                    this.bespokeOrder = response.data.bespoke
                                    this.bespokeOrder.created = this.bespokeOrder.created.split("T")[0] + ' ' + this.bespokeOrder.created.split("T")[1].split(".")[0]

                                    // window.sessionStorage.setItem('_bespokeOrderHeader', JSON.stringify(this.$parent.bespokeOrder));

                                    this.$nextTick(() => { // Loading should be closed asynchronously
                                        loadingInstance.close();
                                    });

                                    document.getElementById("message").innerText = "Order Successfully Updated"
                                    document.getElementById("message").classList.add('component__message-base', 'component__message-success')
                                    this.showHideElements("message", 'block')
                                })
                                .catch(error => {
                                    this.$nextTick(() => { // Loading should be closed asynchronously
                                        loadingInstance.close();
                                    });
                                    document.getElementById("message").innerText = "There was a problem updating the order - please try again"
                                    document.getElementById("message").classList.add('component__message-base', 'component__message-fail')
                                    this.showHideElements("message", 'block')
                                })

                        }

                    } else {
                        return false;
                    }
                })
            },
            updateOrder(bespokeOrderItem) {
                this.$refs[bespokeOrderItem].validate((valid) => {
                    if (valid) {
                        let loadingInstance = Loading.service({
                            // fullscreen: true,
                            background: 'white'
                        });

                        this.bespokeOrderItem.sourceId = this.bespokeOrder.code;
                        this.bespokeOrderItem.billDescription = this.bespokeOrder.jobName;
                        this.bespokeOrderItem.source = 'BESPOKE';
                        this.bespokeOrderItem.branch = this.bespokeOrder.branch;

                        if (this.bespokeOrderItem.id === '' || this.bespokeOrderItem.id === null || typeof this.bespokeOrderItem.id == 'undefined') {
                            const saveOrder = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Order/Create`
                            console.log(saveOrder)
                            Axios.post(saveOrder, this.bespokeOrderItem, this.returnHeaderUsingToken())
                                .then(response => {
                                    console.log('doing a bespoke post')
                                    console.log(response)
                                    this.bespokeOrderItem = response.data.result
                                    this.$nextTick(() => { // Loading should be closed asynchronously
                                        loadingInstance.close();
                                    });
                                    // this.$parent.bespokeOrder.created = this.$parent.bespokeOrder.created.split("T")[0] + ' ' + this.$parent.bespokeOrder.created.split("T")[1].split(".")[0]
                                    document.getElementById("messageItem").innerText = "Order Successfully Updated"
                                    document.getElementById("messageItem").classList.add('component__message-base', 'component__message-success')
                                    this.showHideElements("messageItem", 'block')
                                })
                                .catch(error => {
                                    this.$nextTick(() => { // Loading should be closed asynchronously
                                        loadingInstance.close();
                                    });
                                    document.getElementById("messageItem").innerText = "There was a problem updating the order - please try again"
                                    document.getElementById("messageItem").classList.add('component__message-base', 'component__message-fail')
                                    this.showHideElements("messageItem", 'block')
                                })
                        } else {

                            // todo patch on the order
                            const bespokeOrderItemUpdate = {
                                id: this.bespokeOrderItem.id,
                                status: this.bespokeOrderItem.status,
                                productCode: this.bespokeOrderItem.productCode,
                                style: this.bespokeOrderItem.style,
                                sourceType: this.bespokeOrderItem.sourceType,
                                pageSize: this.bespokeOrderItem.pageSize,
                                orientation: this.bespokeOrderItem.orientation,
                                lamination: this.bespokeOrderItem.lamination,
                                paperType: this.bespokeOrderItem.paperType,
                                sides: this.bespokeOrderItem.sides,
                                finishing: this.bespokeOrderItem.finishing,
                                specialInstructions: this.bespokeOrderItem.specialInstructions,
                                quantity: this.bespokeOrderItem.quantity,
                                billPrice: this.bespokeOrderItem.billPrice,
                                billVatTotal: this.bespokeOrderItem.billVatTotal,
                                priceMethod: this.bespokeOrderItem.priceMethod,
                                billNetTotal: this.bespokeOrderItem.billNetTotal,
                                billGrossTotal: this.bespokeOrderItem.billGrossTotal,
                                focReason: this.bespokeOrderItem.focReason
                            }

                            const saveOrder = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Order/Patch`
                            Axios.patch(saveOrder, bespokeOrderItemUpdate, this.returnHeaderUsingToken())
                                .then(response => {
                                    console.log('doing a bespoke post')
                                    console.log(response)
                                    this.bespokeOrderItem = response.data.result
                                    this.$nextTick(() => { // Loading should be closed asynchronously
                                        loadingInstance.close();
                                    });
                                    // this.$parent.bespokeOrder.created = this.$parent.bespokeOrder.created.split("T")[0] + ' ' + this.$parent.bespokeOrder.created.split("T")[1].split(".")[0]
                                    document.getElementById("messageItem").innerText = "Order Successfully Updated"
                                    document.getElementById("messageItem").classList.add('component__message-base', 'component__message-success')
                                    this.showHideElements("messageItem", 'block')
                                })
                                .catch(error => {
                                    this.$nextTick(() => { // Loading should be closed asynchronously
                                        loadingInstance.close();
                                    });
                                    document.getElementById("messageItem").innerText = "There was a problem updating the order - please try again"
                                    document.getElementById("messageItem").classList.add('component__message-base', 'component__message-fail')
                                    this.showHideElements("messageItem", 'block')
                                })

                        }

                    } else {
                        return false;
                    }
                })

            },
            getLatestArtwork() {
                this.showUploadDialog = false
                const getArtwork = `${process.env.VUE_APP_INTERNAL_ACCOUNTS}/api/services/app/BespokeFiles/GetAllBySourceIdAsync?sourceid=` + this.bespokeOrderItem.orderId
                console.log(getArtwork)
                Axios.get(getArtwork, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response)
                        this.artwork = response.data.result
                    })
            },
            getPrice() {
                if (this.bespokeOrderItem.productCode !== '' && this.bespokeOrderItem.priceMethod !== '') {
                    const getPrices = `${process.env.VUE_APP_BESPOKEAPIHOST}/api/v1/bespokeapi/BespokeOrders/FindBespokeProductPrice`

                    const price = {
                        quantity: this.bespokeOrderItem.quantity,
                        productRef: this.bespokeOrderItem.productCode,
                        pricingMethod: this.bespokeOrderItem.priceMethod
                    }

                    console.log(price)

                    Axios.post(getPrices, price, this.returnHeaderUsingToken())
                        .then(response => {
                            console.log(response)
                            this.bespokeOrderItem.billNetTotal = response.data.billing.billNetTotal
                            this.bespokeOrderItem.billVatTotal = response.data.billing.billVatTotal
                            this.bespokeOrderItem.billGrossTotal = response.data.billing.billGrossTotal
                            this.bespokeOrderItem.billPrice = response.data.billing.billPrice
                        })
                }
            },
            downloadArtwork(artwork) {
                this.downloadLink(event, artwork.url)
                event.stopPropagation();
            },
            getBranchDetails() {

                let loadingInstance = Loading.service({
                    // fullscreen: true,
                    background: 'white'
                });

                const finalQuery = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search/customerLookupByRef?branchRef=` + this.bespokeOrder.branch
                Axios.get(finalQuery, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response)

                        this.bespokeOrder.deliveryAddress1 = response.data.value[0].address1
                        this.bespokeOrder.deliveryAddress2 = response.data.value[0].address2
                        this.bespokeOrder.deliveryAddress3 = response.data.value[0].address3
                        this.bespokeOrder.deliveryTown = response.data.value[0].town
                        this.bespokeOrder.deliveryCounty = response.data.value[0].county
                        this.bespokeOrder.deliveryPostcode = response.data.value[0].postcode
                        this.bespokeOrder.salesperson = response.data.value[0].territory
                        this.bespokeOrder.name = response.data.value[0].customerName
                        this.bespokeOrder.deliveryName = response.data.value[0].branchName


                        this.$nextTick(() => { // Loading should be closed asynchronously
                            loadingInstance.close();
                        });
                    })
                    .catch(error => {
                        this.$nextTick(() => { // Loading should be closed asynchronously
                            loadingInstance.close();
                        });
                    })

            },
            getDeliveryBranch() {

                let loadingInstance = Loading.service({
                    // fullscreen: true,
                    background: 'white'
                });
                const finalQuery = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search/deliveryBranchLookupByDeliveryDepot?deliveryDepot=` + this.bespokeOrder.deliveryDepot

                // this.$parent.loading = true
                Axios.get(finalQuery, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response)

                        this.bespokeOrder.deliveryAddress1 = response.data.value[0].address1
                        this.bespokeOrder.deliveryAddress2 = response.data.value[0].address2
                        this.bespokeOrder.deliveryAddress3 = response.data.value[0].address3
                        this.bespokeOrder.deliveryTown = response.data.value[0].town
                        this.bespokeOrder.deliveryCounty = response.data.value[0].county
                        this.bespokeOrder.deliveryPostcode = response.data.value[0].postcode
                        this.bespokeOrder.deliveryName = response.data.value[0].branchName

                        this.$nextTick(() => { // Loading should be closed asynchronously
                            loadingInstance.close();
                        });
                    })
                    .catch(error => {
                        this.$nextTick(() => { // Loading should be closed asynchronously
                            loadingInstance.close();
                        });
                    })
            },
            sendOrderToPrint(bespokeOrderItem) {

                let loadingInstance = Loading.service({
                    // fullscreen: true,
                    background: 'white'
                });

                console.log(this.bespokeOrderItem)
                console.log(this.returnHeaderUsingToken())
                this.$refs[bespokeOrderItem].validate((valid) => {
                    if (valid) {

                        const bespokeOrderItemUpdate = {
                            id: this.bespokeOrderItem.id,
                            status: 'ORDERED',
                        }

                        const saveOrder = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Order/Patch`
                        console.log(bespokeOrderItemUpdate)
                        Axios.patch(saveOrder, bespokeOrderItemUpdate, this.returnHeaderUsingToken())
                            .then(response => {
                                console.log('doing a bespoke post')
                                console.log(response)
                                this.bespokeOrderItem = response.data.result
                                this.$nextTick(() => { // Loading should be closed asynchronously
                                    loadingInstance.close();
                                });
                                document.getElementById("messageOrderPrint").innerText = "Order Successfully Sent to Print"
                                document.getElementById("messageOrderPrint").classList.add('component__message-base', 'component__message-success')
                                this.showHideElements("messageOrderPrint", 'block')

                            })
                            .catch(error => {
                                this.$nextTick(() => { // Loading should be closed asynchronously
                                    loadingInstance.close();
                                });
                                document.getElementById("messageOrderPrint").innerText = "There was a problem with sending the order to print - please try again"
                                document.getElementById("messageOrderPrint").classList.add('component__message-base', 'component__message-fail')
                                this.showHideElements("messageOrderPrint", 'block')
                            })
                    } else {
                        return false;
                    }
                })
            },
            updateOrderInformation() {
                console.log('**********************')
                const getBespokeOrderItems = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search/bespokeSearchByBespokeId?bespokeOrderId=` + this.bespokeOrderItem.orderId
                console.log(getBespokeOrderItems)
                Axios.get(getBespokeOrderItems, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log('rifat')
                        console.log(response.data)
                        // this.users = response.data.value
                        this.bespokeOrderItem = response.data.value[0]
                        this.bespokeOrderItem.created = this.bespokeOrderItem.created.split("T")[0] + ' ' + this.bespokeOrderItem.created.split("T")[1].split("Z")[0]
                    })

            },
            showBranchSearch(searchType) {
                this.searchType = searchType
                this.showBranchSearchDialog = true
            }
        },
    };
</script>